import { render, staticRenderFns } from "./oldPersonList.vue?vue&type=template&id=4c9d8c49&scoped=true"
import script from "./oldPersonList.vue?vue&type=script&lang=js"
export * from "./oldPersonList.vue?vue&type=script&lang=js"
import style0 from "./oldPersonList.vue?vue&type=style&index=0&id=4c9d8c49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d8c49",
  null
  
)

export default component.exports